import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import { birchmountGiftCardOperation } from 'actions/EntityActions';
import { formInput } from 'actions/FormActions';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';
import LOOKUP from 'constants/lookup';

class BirchmountGiftCardCheckBalance extends Component {
    constructor(props, context) {
        super(props, context);
    }

    checkBalance = () => {
        let p = this.props;
        let model = {
            BranchId: p.branchId,
            CardNumber: p.cardNumber,
            Operations: LOOKUP.BirchmountGiftCardOperationType.CheckBalance,
            PIN: p.pinNumber
        };
        this.props.birchmountGiftCardOperation(model);
    }

    render() {
        const { t } = this.props; 
        let p = this.props;
        return (
            <DialogInput
                title={<DialogHeaderWithClose text={t('pos.giftCard.activation.label')} classicClass="posDialogClassic" handleClose={() => this.props.onCancel()} />}
                actions={[
                    <Button
                        key={1}
                        name="buttonRefundDialogCancel"
                        type="Button"
                        className="corner_X"
                        primary={false}
                        onTouchTap={() => this.props.onCancel()} />,
                    <Button
                        key={2}
                        className="pull-right space btnNewBrandPOS"
                        name="buttonRefundDialogConfirm"
                        label={t('common.confirm')}
                        primary={true}
                        onTouchTap={() => this.checkBalance()} />]}
                modal={true}
                style={{ zIndex: '980' }}
                open={this.props.show}
                autoScrollBodyContent={true}>
                <div>
                    <h4 className="purpleText">{t('pos.birchmountGiftCard.checkBalance.fillUpInfoToCheckBalance')}</h4>
                    <div className="row">
                        <div className="col-lg-12">
                            <TextInput name={`${p.name}CardNumber`}
                                fullWidth={true}
                                label={t('common.cardNum')}
                                floatingLabelText={t('common.cardNum')}
                                hintText={t('common.cardNum')} />
                        </div>
                        <div className="col-lg-12">
                            <TextInput name={`${p.name}PIN`}
                                fullWidth={true}
                                label={t('pos.giftCard.pinNum.label')}
                                floatingLabelText={t('pos.giftCard.pinNum.label')}
                                hintText={t('pos.giftCard.pinNum.hintText')} />
                        </div>
                    </div>
                </div>
            </DialogInput>
        );
    }
}

function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        cardNumber: state.form[`BirchmountGiftCardCheckBalanceCardNumber`] || '',
        pinNumber: state.form[`BirchmountGiftCardCheckBalancePIN`] || ''
    };
}

function mapDispatchToProps(dispatch) {
    return {
        birchmountGiftCardOperation: (model) => dispatch(birchmountGiftCardOperation(model)),
        formInput: (value, name) => dispatch(formInput(value, name))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(BirchmountGiftCardCheckBalance));